import React, { useContext } from 'react';

import classNames from 'classnames';

import { CustomModal } from '@shared/ui';

import { CompanyBlock } from './BodyComponents/CompanyBlock';
import { EmployeeBlock } from './BodyComponents/EmployeeBlock';
import { NotBindBlock } from './BodyComponents/NotBindBlock';
import { TabPanel } from './BodyComponents/TabPanel';
import { ModalAddContext } from './ModalAdd';
import cls from './ModalAdd.module.css';
import { Form } from '../../../../components/UI/Form/Form';

const blockMapping = {
    company: <CompanyBlock />,
    employee: <EmployeeBlock />,
    notBind: <NotBindBlock />,
};
export const AccountAddBody = () => {
    const { activeTab } = useContext(ModalAddContext);

    return (
        <CustomModal.Body>
            <div className={classNames(cls.accountBody)}>
                <TabPanel />
                <Form>{blockMapping[activeTab]}</Form>
            </div>
        </CustomModal.Body>
    );
};
